import { useRef } from 'react';

type ResultBox<T> = { constant: T };

/**
 * Custom hook for maintaining a constant reference to a value accross renders
 *
 * @param fn function to produce value with constant reference
 */
const useConstant = <T>(fn: () => T): T => {
  const ref = useRef<ResultBox<T>>();

  if (!ref.current) {
    ref.current = { constant: fn() };
  }

  return ref.current.constant;
};

export { useConstant };
